<div #statisticsContainer>
  <svg id="statistics-graph" width="100%" attr.height="{{ svgComponentHeight }}px"></svg>
</div>
